import React from 'react';
import Typography from '@material-ui/core/Typography';

interface Props {
  align?: 'left' | 'right' | 'inherit' | 'center' | 'justify';
}

const H5: React.FC<Props> = ({ children, align }) => (
  <Typography variant="h5" align={align}>
    {children}
  </Typography>
);

H5.defaultProps = {
  align: 'left',
};

export default H5;
